import React from 'react';
import { Loader2, X } from 'lucide-react';
import { PRODUCT_NAME_MARKETING } from '../../../constants';
import { LEAD_USER_MESSAGES } from '../../../services/leadTypes';
import type { T05LeadFormState } from '../../../hooks/useT05LeadForm';

interface T05LeadModalProps {
  lead: Pick<
    T05LeadFormState,
    | 'isLeadModalOpen'
    | 'closeLeadModal'
    | 'formStep'
    | 'leadSuccessStatus'
    | 'formData'
    | 'setFormData'
    | 'submitLead'
    | 'isSubmitting'
    | 'leadFeedback'
    | 'leadFeedbackKind'
  >;
}

export const T05LeadModal: React.FC<T05LeadModalProps> = ({ lead }) => {
  const {
    isLeadModalOpen,
    closeLeadModal,
    formStep,
    leadSuccessStatus,
    formData,
    setFormData,
    submitLead,
    isSubmitting,
    leadFeedback,
    leadFeedbackKind,
  } = lead;

  if (!isLeadModalOpen) return null;

  return (
    <div className="t05-modal-backdrop" role="dialog" aria-modal="true" aria-labelledby="t05-modal-title">
      <div className="t05-modal">
        <button
          type="button"
          className="t05-nav__ghost"
          style={{ position: 'absolute', top: '1rem', right: '1rem' }}
          onClick={closeLeadModal}
          aria-label="Schließen"
        >
          <X size={20} />
        </button>
        {formStep === 'form' ? (
          <>
            <h2 id="t05-modal-title">Kostenlose Analyse</h2>
            <p>
              Kurzes Gespräch zu Infrastruktur, Datenschutz und {PRODUCT_NAME_MARKETING}-Einsatz in Ihrer Kanzlei.
            </p>
            <form onSubmit={submitLead} autoComplete="on">
              <label htmlFor="t05-name">Name</label>
              <input
                id="t05-name"
                name="name"
                value={formData.name}
                onChange={(e) => setFormData((d) => ({ ...d, name: e.target.value }))}
                autoComplete="name"
                required
              />
              <label htmlFor="t05-email">E-Mail</label>
              <input
                id="t05-email"
                name="email"
                type="email"
                value={formData.email}
                onChange={(e) => setFormData((d) => ({ ...d, email: e.target.value }))}
                autoComplete="email"
                required
              />
              <label htmlFor="t05-company">Kanzlei / Firma</label>
              <input
                id="t05-company"
                name="organization"
                value={formData.company}
                onChange={(e) => setFormData((d) => ({ ...d, company: e.target.value }))}
                autoComplete="organization"
              />
              <input
                type="text"
                name="hp_trap"
                value={formData.hpTrap}
                onChange={(e) => setFormData((d) => ({ ...d, hpTrap: e.target.value }))}
                tabIndex={-1}
                autoComplete="off"
                aria-hidden
                style={{ position: 'absolute', left: '-9999px', opacity: 0, height: 0, width: 0 }}
              />
              {leadFeedback && (
                <p
                  className={`t05-lead-feedback t05-lead-feedback--${leadFeedbackKind}`}
                  role="alert"
                  aria-live="polite"
                >
                  {leadFeedback}
                </p>
              )}
              <div className="t05-modal__actions">
                <button type="submit" className="t05-btn t05-btn--primary" disabled={isSubmitting}>
                  {isSubmitting ? <Loader2 size={18} className="animate-spin" /> : 'Absenden'}
                </button>
                <button type="button" className="t05-btn t05-btn--ghost" onClick={closeLeadModal}>
                  Abbrechen
                </button>
              </div>
            </form>
          </>
        ) : (
          <>
            <h2 id="t05-modal-title">
              {leadSuccessStatus === 'partial' ? 'Anfrage gespeichert' : 'Anfrage erhalten'}
            </h2>
            <p
              className={`t05-lead-feedback t05-lead-feedback--${
                leadSuccessStatus === 'partial' ? 'warning' : 'success'
              }`}
            >
              {leadSuccessStatus === 'partial' ? LEAD_USER_MESSAGES.partial : LEAD_USER_MESSAGES.success}
            </p>
            <button type="button" className="t05-btn t05-btn--primary" onClick={closeLeadModal}>
              Schließen
            </button>
          </>
        )}
      </div>
    </div>
  );
};
